var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 488.4 488.4",
    style: {
      enableBackground: "new 0 0 488.4 488.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 103.1,
    y: 453.5,
    width: 282.2,
    height: 34.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 143,
    y: 367.5,
    width: 202,
    height: 66.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0v348.1h488.4V0H0z M461.7,311.3c0,5.4-4.3,9.7-9.7,9.7H36.4c-5.4,0-9.7-4.3-9.7-9.7V36.8c0-5.4,4.3-9.7,9.7-9.7H452 c5.4,0,9.7,4.3,9.7,9.7L461.7,311.3L461.7,311.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1,301.6h396.2V46.5H46.1V301.6z M309.7,194.2c0-1.9,1.2-3.5,2.7-4.3l54.7-25.2l-54.7-24.8c-1.6-0.8-2.7-2.3-2.7-4.3 V116c0-3.3,3.4-5.4,6.3-4l82.4,38.3c1.6,0.8,2.7,2.3,2.7,4.3v21.7c0,1.9-1.2,3.5-2.7,4.3L316,218.5c-3,1.4-6.4-0.8-6.4-4.1v-20.2 H309.7z M188.5,253.2l75.8-162.5c0.8-1.6,2.3-2.7,4.3-2.7h17.2c3.5,0,5.9,3.7,4.4,6.9l-75.9,162.5c-0.8,1.6-2.3,2.7-4.3,2.7h-17.2 C189.4,260.1,187,256.4,188.5,253.2z M87.6,154.7c0-1.9,1.2-3.5,2.7-4.3l82.5-38.3c2.9-1.4,6.3,0.8,6.3,4v20 c0,1.9-1.2,3.5-2.7,4.3l-54.7,24.8l54.7,25.2c1.6,0.8,2.7,2.3,2.7,4.3v20.4c0,3.2-3.3,5.4-6.3,4l-82.5-37.9 c-1.6-0.8-2.7-2.3-2.7-4.3C87.6,176.9,87.6,154.7,87.6,154.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.69b7f3421c9a376a53f05fe528bbe99b.svg";
export { ForwardRef as ReactComponent };